import React from 'react';
import {Link, NavLink, useNavigate} from "react-router-dom";
import {Alert, Button} from "reactstrap";
import {StyledContainer} from '../../style';
import {apiAcceptTncs} from "../../common/state/ducks/awsApiGw/actions";
import { useDispatch } from 'react-redux';

const TandC = () => (
    <div className={"p-3"}>
        <h2>Introduction</h2>
        <ol type="A">
            <li>Healthpoint has created and maintains a directory of service information on health service providers
                that the Licensee wishes to use for a specific business purpose outlined in the section of the online
                sign up process designated "Your intended API usage".
            </li>
            <br/>
            <li>Healthpoint is willing to license its directory of service information on health service providers to
                the Licensee, and allow the Licensee to access such information from the Licensee Application using the
                API, on the terms and conditions contained in this Deed Poll.
            </li>
        </ol>
        <div className="customListBox">
            <strong>It is agreed :</strong>
            <br/>
            <br/>
            <h2>1. Interpretation</h2>
            <hr/>
            <ol>
                <li>In this Deed Poll, unless the context otherwise requires:<br/>
                    <br/>
                    <strong>AI</strong> means Artificial Intelligence;<br/>
                    <br/>
                    <strong>AI System</strong> has the meaning given to it in clause 3.1(a);<br/>
                    <br/>
                    <strong>API</strong> means the application programming interface provided by Healthpoint to the
                    Licensee so that the Licensee can use the Directory Information with its own Licensee
                    Application;<br/>
                    <br/>
                    <strong>API Restrictions</strong> means the restrictions on the use of the API and/or the
                    Directory Information (as used with the Licensee Application), as set out in this Deed Poll;<br/>
                    <br/>
                    <strong>Authorised Service Providers</strong> means any third party technology partner of the
                    Licensee that provides the Licensee with services relating to the development, support and/or
                    maintenance of the Licensee Application, solely for sandbox testing purposes and not for any
                    production or commercial purpose;<br/>
                    <br/>
                    <strong>Commencement Date</strong> means the date on which this Deed Poll is signed by both
                    parties;<br/>
                    <br/>
                    <strong>Confidential Information</strong> means all information exchanged between the parties to
                    this Deed Poll, whether in writing, electronically or orally, which is marked confidential or is
                    by its nature clearly confidential or could reasonably be expected to be confidential, but does not
                    include information which is, or becomes, publicly available other than through unauthorised
                    disclosure by either party in breach of clause 5;<br/>
                    <br/>
                    <strong>Directory Information</strong> means Healthpoint's national directory of service
                    information on health service providers, including data as described in this Deed Poll, in XML or
                    JSON format;<br/>
                    <br/>
                    <strong>Healthpoint Trade Marks</strong> means any of Healthpoint's trade marks;<br/>
                    <br/>
                    <strong>Intellectual Property Rights</strong> means all property in the Licensed Material and
                    rights to patents, trade marks (including the Healthpoint Trade Marks), service marks, trade names,
                    inventions, trade secrets, copyright, moral rights, rights in a design, look and feel, know-how,
                    confidential information and all or any other intellectual property rights whether or not registered
                    relating to the origin, collation, programming, operating, servicing and/or updating of the
                    Licensed Material and any related updates, enhancements or modifications;<br/>
                    <br/>
                    <strong>Licence Fee</strong> means the sum payable (if specified in the Schedule) by the Licensee
                    for the use of the Licensed Material as described in the Schedule;<br/>
                    <br/>
                    <strong>Licensed Materials</strong> means the Directory Information and the API;<br/>
                    <br/>
                    <strong>Licensee Application</strong> means the software and other technology offered to customers
                    by the Licensee;<br/>
                    <br/>
                    <strong>Permitted Purpose</strong> means the integration of the Licensed Materials into the
                    Licensee Application solely to enable the Licensee to test and evaluate one or more of the use
                    cases described below:<br/>
                    <ol type="a">
                        <li>concept testing functionality that allows end users to search for, identify, or navigate
                            to health providers, health services, or health facilities recorded in the Directory
                            Information by reference to criteria such as location, service type, availability, or
                            eligibility;</li>
                        <li>the display or presentation of health provider and service information to end users of
                            the Licensee Application, including contact details, locations, service descriptions,
                            and availability information, for the purpose of facilitating access to health
                            services;</li>
                        <li>the pre-population or validation of health provider details within clinical, referral,
                            care coordination, enrolment, or triage workflows embedded in the Licensee
                            Application;</li>
                        <li>the generation of health service insights or reporting within business intelligence
                            applications, dashboards, or internal planning tools, including analysis of service
                            availability, coverage gaps, or provider distribution for the purpose of informing
                            health system planning or resource allocation; and</li>
                        <li>the exploration and evaluation of potential use cases for the Directory Information,
                            whether or not the Licensee has identified a specific Licensee Application, that are not
                            otherwise described in paragraphs (a) to (d) above, including feasibility assessment,
                            provided that any such exploration must be conducted solely within the sandbox
                            environment, must comply with the exclusions set out below, and does not authorise the
                            Licensee to deploy any use case into a production or live environment without
                            Healthpoint's prior written approval.</li>
                    </ol>
                    <br/>
                    in each case solely for non-production, sandbox testing purposes and not for any live, commercial,
                    or operational deployment.<br/>
                    <br/>
                    The Permitted Purpose does not include, and the Licensee must not use the Licensed Materials for:<br/>
                    <ol type="a">
                        <li>building, operating, or commercialising any health directory, provider database, or data
                            product that replicates or competes with Healthpoint's directory services or any other
                            Healthpoint product;</li>
                        <li>insurance underwriting, risk assessment, claims processing, or any other financial
                            services purpose;</li>
                        <li>marketing, advertising, or solicitation directed at health providers or health consumers,
                            including the use of provider contact details for direct marketing or lead
                            generation;</li>
                        <li>resale, sublicensing, or redistribution of the Directory Information, whether in raw,
                            aggregated, derived, or transformed form;</li>
                        <li>any purpose that involves the systematic extraction, scraping, or bulk copying of the
                            Directory Information, whether for AI training, dataset creation, or otherwise; or</li>
                        <li>any purpose that is unlawful or that would breach any applicable privacy law, health
                            information standard, or regulatory requirement relating to health data in New
                            Zealand.</li>
                    </ol>
                    <br/>
                    <strong>Permitted Users</strong> means the Licensee's Representatives, subject to the limitations
                    of any licence allocations;<br/>
                    <br/>
                    <strong>Portal</strong> means Healthpoint's online developer portal through which sandbox access
                    is granted and this Deed Poll is accepted;<br/>
                    <br/>
                    <strong>Representatives</strong> means staff, personnel and advisors, including employees,
                    contractors, subcontractors and consultants of a party;<br/>
                    <br/>
                    <strong>Working Day</strong> means a day other than a Saturday, Sunday or a public holiday in
                    Auckland, New Zealand.
                </li>
                <br/>
                <li>In this Deed Poll:
                    <ol type="a">
                        <li>clause and other headings are for ease of reference only and will not be deemed to form
                            any part of the context or to affect the interpretation of this Deed Poll;</li>
                        <li>the word person includes a corporation; and</li>
                        <li>words importing the singular include the plural and vice versa.</li>
                    </ol>
                </li>
            </ol>
            <h2>2. Grant of Licence</h2>
            <hr/>
            <ol>
                <li>Subject to the Licensee's compliance with this Deed Poll, Healthpoint grants to the Licensee a
                    non-exclusive, non-transferable, revocable licence during the term of this Deed Poll to use the
                    Licensed Material strictly for the Permitted Purpose and in a manner that complies with the API
                    Restrictions.
                </li>
                <br/>
                <li>The licence granted under clause 2.1 permits the Licensee to:
                    <ol type="a">
                        <li>electronically reproduce and distribute the Directory Information strictly for the
                            Permitted Purpose; and</li>
                        <li>print and distribute the Directory Information strictly for the Permitted Purpose,</li>
                        <li>subject always to the API Restrictions and any reasonable guidelines that may from time to time
                    be established by Healthpoint with respect to the Directory Information.</li>
                    </ol>
                </li>
                <br/>
                <li>The Licensee will:
                    <ol type="a">
                        <li>not use the Licensed Material for any purpose other than the Permitted Purpose or in a
                            manner that contravenes the API Restrictions;</li>
                        <li>not use the Licensed Material to compete (directly or indirectly) with Healthpoint, by
                            (for example) using the Licensed Material to create the Licensee's or a third party's
                            own directory of health service provider information or other directory or service that
                            contains the information in the Licensed Material;</li>
                        <li>not make the Licensed Material available to any third party except in accordance with
                            the Permitted Purpose or otherwise with the prior written consent from Healthpoint. For
                            the avoidance of doubt and without limitation, if the Licensee is a District Health
                            Board, the Licensee will not make the Licensed Material available to any third party
                            whether or not funded by that DHB;</li>
                        <li>not remove or modify any copyright, trade mark (including the Healthpoint Trade Marks)
                            or other proprietary right notice that is in, or embedded in, the Licensed
                            Material;</li>
                        <li>not use the API to connect to any information source, application or platform other
                            than the Licensee Application and Directory Information;</li>
                        <li>not remove, disable, circumvent or attempt to undermine the integrity of any security
                            or technical measures that control access to the API or the Directory Information;</li>
                        <li>take all necessary steps to ensure the Licensed Material is protected at all times from
                            misuse, damage, destruction or any form of unauthorised access, use or copying;</li>
                        <li>comply with the reasonable directions of Healthpoint in relation to the access and use
                            of the Licensed Material;</li>
                        <li>not use the sandbox environment or any Directory Information obtained through it for
                            any production, commercial, or live operational purpose;</li>
                        <li>not make available to any third party any output, data, or content derived from sandbox
                            API calls, whether for payment or otherwise; and</li>
                        <li>comply with any sandbox-specific call limits, sandbox term (which shall not exceed 90
                            days from the Commencement Date unless Healthpoint agrees in writing to an extension),
                            and testing guidelines published by Healthpoint from time to time. Upon expiry of the
                            sandbox term, all sandbox access will be suspended and the Licensee must enter into
                            Healthpoint's then-current production API licence Deed Poll to continue access.</li>
                    </ol>
                </li>
                <br/>
                <li>The Licensee acknowledges and agrees that Healthpoint may:
                    <ol type="a">
                        <li>modify the API or release subsequent versions of the API. The Licensee is responsible
                            for ensuring the Licensee Application integrates with any modified or updated version
                            of the API;</li>
                        <li>discontinue the API at any time. No such discontinuance will be a breach of this Deed
                            Poll or in any way be deemed to be a termination of this Deed Poll;</li>
                        <li>prior to the Licensee Application (as it operates with the Directory Information) being
                            made available to third parties, request that the Licensee demonstrates to Healthpoint
                            that the Licensee Application operates with the Directory Information in the manner
                            specified, or other contemplated by, Healthpoint. Healthpoint may request the Licensee
                            to make any reasonable changes to the integration between the Licensee Application and
                            the Directory Information before they are made available to third parties;</li>
                        <li>terminate the licence granted under clause 2.1 by giving the Licensee 5 Working Days'
                            prior notice, if the Licensee Application does not operate with the Directory
                            Information in the manner specified, or as contemplated, by Healthpoint; and</li>
                        <li>without prejudice to the API Restrictions, limit the number of API calls to the
                            Directory Information (using the API) that the Licensee will be permitted to make
                            during any given period. Healthpoint will determine, at its sole discretion, call
                            limits based on any factors it considers relevant, including how the Licensee
                            Application is used or the anticipated volume of use associated with the Licensee
                            Application. Healthpoint may charge the Licensee for API calls that exceed the call
                            limits determined by Healthpoint.</li>
                    </ol>
                </li>
            </ol>
            <h2>3. Parties' Responsibilities</h2>
            <hr/>
            <ol>
                <li>Healthpoint will:
                    <ol type="a">
                        <li>make the Licensed Material available to the Licensee on, or as soon as is reasonably
                            practicable after, the Commencement Date; and</li>
                        <li>thereafter enable access to updated Directory Information via an automated process.</li>
                    </ol>
                </li>
                <br/>
                <li>The Licensee will:
                    <ol type="a">
                        <li>acknowledge Healthpoint as the supplier of the Directory Information:
                            <ol type="i">
                                <li>on every occasion, the Directory Information is used; and</li>
                                <li>on each presentation slide or document page where the Directory Information is
                                    relied on or referred to;</li>
                            </ol>
                        </li>
                        <li>comply with all applicable law in performing its obligations and exercising its rights
                            under this Deed Poll;</li>
                        <li>ensure that the Directory Information is kept secure and take prompt and proper remedial
                            action against unauthorised access, copying, modification, storage, reproduction,
                            display or distribution of the Directory Information that would breach the terms of
                            this Deed Poll;</li>
                        <li>promptly notify Healthpoint of any misuse of, or unauthorised access to, the Directory
                            Information and fully co-operate with Healthpoint to remedy the issue.</li>
                    </ol>
                </li>
            </ol>
            <h2>4. Intellectual Property Rights</h2>
            <hr/>
            <ol>
                <li>The Licensee acknowledges that the Intellectual Property Rights belong to Healthpoint or its
                    licensors and the Licensee will not dispute such ownership.
                </li>
                <br/>
                <li>The Licensee may not copy the Licensed Material in whole or in part in any visual or
                    machine-readable form, except to the extent that such copying is necessary for the Permitted
                    Purpose or the Licensee's own back-up purposes.
                </li>
                <br/>
                <li>The Licensee will:
                    <ol type="a">
                        <li>not reproduce, translate, reverse-engineer, adapt, vary or modify the Licensed Material,
                            except as expressly permitted by this Deed Poll;</li>
                        <li>not transfer, assign or otherwise deal in or grant a security interest in the Licensed
                            Material or the Licensee's rights under this Deed Poll.</li>
                    </ol>
                </li>
                <br/>
                <li>The Licensee acknowledges and agrees that Healthpoint may independently create products or
                    services that may be the same or similar to, or competing with, the Licensee Application.
                    Nothing in this Deed Poll will be construed as restricting or preventing Healthpoint from
                    creating and fully exploiting such products or services.
                </li>
            </ol>
            <h2>5. Confidentiality</h2>
            <hr/>
            <ol>
                <li>Each party (the Recipient) will keep confidential all Confidential Information
                    obtained from the other party (Disclosing Party) and, except as permitted by
                    clauses 5.2 and 5.3, will not use for itself or its own benefit, or divulge or make available
                    the same to a third party without the written consent of the Disclosing Party.
                </li>
                <br/>
                <li>The Recipient may divulge Confidential Information only to those of its employees, agents and
                    contractors who are directly involved in fulfilling the Recipient's obligations under this Deed
                    Poll and will ensure that such employees, agents and contractors are aware of and comply with
                    these obligations as to confidentiality.
                </li>
                <br/>
                <li>The obligations of confidentiality set out in clause 5.1 will not apply to information that:
                    <ol type="a">
                        <li>the Recipient can clearly show was independently available to it from a third party
                            having the right to disclose it;</li>
                        <li>at the time of disclosure is in the public domain, or subsequently enters the public
                            domain, through no fault of the Recipient or any other person to whom it discloses the
                            information; or</li>
                        <li>the Recipient is obliged by law to disclose, provided that it has first advised the
                            Disclosing Party of this obligation, has allowed the Disclosing Party reasonable time
                            to avoid the disclosure having to be made, and has given the Disclosing Party such
                            assistance (at the Disclosing Party's cost) as the Disclosing Party reasonably requests
                            in doing this.</li>
                    </ol>
                </li>
                <br/>
                <li>Each party will on demand and, in any event, on termination of this Deed Poll, deliver to the
                    other party all Confidential Information and any other document or information supplied by or
                    obtained from the other party relating to this Deed Poll.
                </li>
                <br/>
                <li>The obligations of the parties under this clause 5 will survive termination of this Deed Poll.
                </li>
            </ol>
            <h2>6. Warranty</h2>
            <hr/>
            <ol>
                <li>Healthpoint warrants that:
                    <ol type="a">
                        <li>it has full power and authority to license the Licensed Material to the Licensee;
                            and</li>
                        <li>to the best of its knowledge and belief the Licensed Material does not infringe any New
                            Zealand copyright of any third party.</li>
                    </ol>
                </li>
                <br/>
                <li>Except as expressly provided in this Deed Poll, all representations or warranties (statutory,
                    express or implied), except any which may not lawfully be excluded, are expressly excluded,
                    including without prejudice to the generality of the foregoing, the implied warranties of
                    merchantability and fitness for a particular purpose.
                </li>
                <br/>
                <li>Without limiting clause 6.2, Healthpoint does not warrant the accuracy of, or endorse, the
                    Directory Information or any other information or materials that are made available via the
                    API. If Healthpoint becomes aware that any such information is inaccurate or misleading,
                    Healthpoint will use reasonable endeavours to correct the information.
                </li>
            </ol>
            <h2>7. Limitation of liability</h2>
            <hr/>
            <ol>
                <li>Healthpoint accepts no responsibility or liability for any errors, omissions, offers or details
                    in, or reliance by any person on, the Directory Information.
                </li>
                <br/>
                <li>Notwithstanding anything in this Deed Poll to the contrary, Healthpoint will not be liable
                    under the law of tort, contract or otherwise for any loss of profits or any indirect or
                    consequential loss or damage, however caused, arising out of or in connection with this Deed
                    Poll.
                </li>
                <br/>
                <li>The sandbox environment is provided on an "as is" basis. Healthpoint makes no warranty as to
                    the availability, uptime, accuracy, or fitness for purpose of the sandbox environment.
                    Healthpoint's aggregate liability to the Licensee in connection with this Deed Poll shall not
                    exceed NZD 500.
                </li>
            </ol>
            <h2>8. Default and termination</h2>
            <hr/>
            <ol>
                <li>Either party may terminate this Deed Poll immediately by notice in writing to the other party
                    if that other party:
                    <ol type="a">
                        <li>breaches any of its obligations under this Deed Poll and fails to remedy the breach
                            within 30 days after notice from the party giving notice requiring the breach to be
                            remedied; or</li>
                        <li>becomes bankrupt, goes or is put into liquidation, has a receiver or statutory manager
                            appointed of any of its assets, becomes insolvent, ceases to carry on its business or
                            makes any composition or arrangement with its creditors.</li>
                    </ol>
                </li>
                <br/>
                <li>Either party may terminate this Deed Poll on giving not less than 30 days' written notice to
                    the other party.
                </li>
                <br/>
                <li>Immediately following termination of this Deed Poll the Licensee will:
                    <ol type="a">
                        <li>cease to use and destroy all copies of the Licensed Material in whatever form possessed
                            by, or under the control of, the Licensee;</li>
                        <li>deactivate the Licensee Application or otherwise remove its integration with the
                            Directory Information; and</li>
                        <li>cease to use the Healthpoint Trade Marks.</li>
                    </ol>
                </li>
            </ol>
            <h2>9. Dispute Resolution</h2>
            <hr/>
            <ol>
                <li>If a dispute arises under this Deed Poll (Dispute) neither party may commence any court or
                    arbitration proceedings relating to the Dispute unless it has complied with the following
                    provisions of this clause 9, except where the party seeks urgent interlocutory relief.
                </li>
                <br/>
                <li>The party claiming a Dispute has arisen must give written notice to the other party specifying
                    the nature of the Dispute.
                </li>
                <br/>
                <li>On receipt of the notice given pursuant to clause 9.1, the parties will use all reasonable
                    endeavours to resolve the Dispute by discussion, consultation and good faith negotiations.
                </li>
                <br/>
                <li>Any Dispute that is not resolved within 15 Working Days of the notice referred to in to clause
                    9.2 (or within such longer period agreed in writing by the parties) may be submitted by either
                    party, by giving written notice to the other party, to be finally determined by the arbitration
                    of a single arbitrator. The arbitrator will be appointed by the parties or, failing agreement
                    of the parties, within 5 Working Days of the notice requiring arbitration, by the President of
                    the New Zealand Law Society, on application of either party. The arbitration will be conducted
                    as soon as possible and in accordance with the Arbitration Act 1996.
                </li>
                <br/>
                <li>Nothing in this clause 9 will prevent a party from seeking urgent interlocutory relief from a
                    court of competent jurisdiction.
                </li>
            </ol>
            <h2>10. Force Majeure</h2>
            <hr/>
            <ol>
                <li>Neither party will be responsible or liable for any delay or failure in the performance of its
                    obligations under this Deed Poll if such delay or failure is due to circumstances outside its
                    reasonable control, including acts, omissions, systems, networks, equipment or data of any
                    third party (including, without limitation, the Internet or any telecommunications or utilities
                    network or equipment), acts of God, natural disaster, riot, terrorism, malicious damage or fire
                    (each an Event of Force Majeure).
                </li>
                <br/>
                <li>The party affected must:
                    <ol type="a">
                        <li>immediately notify the other party and provide full information concerning the Event of
                            Force Majeure, including an estimate of time likely to be required to overcome the
                            event; and</li>
                        <li>continue to perform its obligations under this Deed Poll as far as reasonably
                            practicable.</li>
                    </ol>
                </li>
            </ol>
            <h2>11. General</h2>
            <hr/>
            <ol>
                <li>Any notice to be given in terms of this Deed Poll must be made in writing, by email or by fax
                    sent to the registered office or principal place of business of the other party or to such
                    other address as may be notified by either party to the other from time to time. Any
                    communication by email or fax will be deemed to be received when transmitted to the correct
                    email or fax address of the recipient. Any other communication in writing will be deemed to be
                    received when left at the specified address of the recipient or on the third Working Day
                    following the date of posting.
                </li>
                <br/>
                <li>This Deed Poll will not be deemed to create a partnership, joint venture or agency relationship
                    of any kind between the parties.
                </li>
                <br/>
                <li>No waiver of any breach of this Deed Poll will be deemed to be a waiver of any other or any
                    subsequent breach. The failure of any party to enforce any provision of this Deed Poll will not
                    be interpreted as a waiver of the provision.
                </li>
                <br/>
                <li>This Deed Poll constitutes the entire agreement between the parties and supersedes all previous
                    negotiations, commitments and/or writings, provided that, where a confidentiality agreement has
                    previously been signed by the parties, that confidentiality agreement will continue in full
                    force and effect, except to the extent of any inconsistency with this Deed Poll.
                </li>
                <br/>
                <li>Healthpoint may amend the terms of this Deed Poll by publishing the amended terms to the Portal
                    and providing the Licensee with not less than 30 days' prior written notice. The Licensee's
                    continued use of the sandbox API following the expiry of the notice period will constitute
                    acceptance of the amended terms. If the Licensee does not accept the amended terms, it must
                    cease all use of the sandbox environment before the expiry of the notice period and notify
                    Healthpoint in writing.
                </li>
                <br/>
                <li>The Licensee will not assign or transfer this Deed Poll or any of its rights or obligations
                    hereunder without the prior written consent of Healthpoint.
                </li>
                <br/>
                <li>If any provision of this Deed Poll is invalid or unenforceable, the remaining provisions of
                    this Deed Poll will not be affected and will continue in full force.
                </li>
                <br/>
                <li>This Deed Poll may be executed by the parties in counterparts, each of which will be deemed to
                    be an original and all of which will constitute one and the same Deed Poll.
                </li>
                <br/>
                <li>This Deed Poll is subject to the laws of New Zealand and the parties submit to the
                    non-exclusive jurisdiction of the New Zealand courts.
                </li>
            </ol>
            <h2>Acceptance</h2>
            <hr/>
            <p>This instrument is executed by Healthpoint Limited as a deed poll and takes effect upon
                publication to the Portal. No signature by the Licensee is required. This Deed Poll is intended
                to be legally binding on the Licensee without the need for consideration from the Licensee, by
                virtue of its execution as a deed.
            </p>
            <p>By clicking "Accept" through the Portal, the individual accepting this Deed Poll represents and
                warrants that: (a) they are duly authorised to accept this Deed Poll on behalf of the Licensee;
                (b) the Licensee is a validly incorporated company or other legal entity; and (c) this Deed
                Poll constitutes a binding obligation of the Licensee enforceable in accordance with its terms.
                The Licensee's click acceptance constitutes acceptance and delivery of this Deed Poll under New
                Zealand law and binds the Licensee to all terms of this Deed Poll from the Commencement Date.
            </p>
        </div>
    </div>
);

const Component = ({
    isAuthenticated,
    tncAccepted,
}) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const isTncsAccepted = !!tncAccepted ;
    return (
        <StyledContainer>
            <h1>Healthpoint API Deed Poll</h1>
            <br/>
            <div className="card" style={{overflowY: "scroll", height: 400}}>
                <TandC/>
            </div>
            <br/>
            <p>These terms of use were last updated on 7 May 2026.</p>
            {(!isAuthenticated && !isTncsAccepted) &&
            <Alert color="warning" className="text-center">
                <p><Link to={"/login"}>Sign-in</Link> to accept.</p>
            </Alert>
            }
            {(isAuthenticated && !isTncsAccepted) &&
            <Alert color="warning" className="text-center">
                <Button onClick={async () => {
                    await new Promise((resolve,reject) => {
                        dispatch(apiAcceptTncs({resolve,reject}));
                    });
                    navigate("/dashboard");
                }}>Accept</Button>
            </Alert>
            }
            {(isAuthenticated && isTncsAccepted) &&
            <Alert color="success" className="text-center">
                <h4 className="alert-heading text-center">
                    Terms and conditions accepted
                </h4>
                <p>
                    You accepted these on {tncAccepted.toString()}.
                    Go to your{' '} <NavLink to="/dashboard">dashboard</NavLink>.
                </p>
            </Alert>
            }
        </StyledContainer>
    );
};

export default Component;
